export const CLIENT_ADDRESS_SEARCH_MODAL_NAME = 'clientAddressSearch';
